/** @jsxImportSource @emotion/react */

import CloseBigIcon from '../Icons/close_big.svg';

import type { Theme } from '@emotion/react';
import type { Interpolation } from '@emotion/serialize';

type FilterPillRemoveProps = {
  label: string;
  onClick: React.MouseEventHandler;
  cssProps?: Interpolation<Theme>;
};

const containerClassFn = (t) => ({
  alignItems: 'center',
  backgroundColor: t.color.grey.g92,
  borderRadius: '2px',
  color: 'hsl(0, 0%, 20%)',
  cursor: 'default',
  display: 'flex',
  fontSize: t.font.size.small,
  lineHeight: '1.5rem',
  padding: '2px 8px 2px 12px'
});

const svgClassFn = (t) => ({
  height: '14px',
  marginLeft: '0.25rem',
  width: '14px',

  path: {
    fill: t.color.grey.g20
  },

  ':hover path': {
    fill: t.color.primary
  }
});

const FilterPillRemove: React.FC<FilterPillRemoveProps> = ({ label, onClick, cssProps }) => {
  return (
    <button
      type="button"
      onClick={onClick}
      css={(t) => ({ ...containerClassFn(t), ...(cssProps as object) })}
    >
      {label} <CloseBigIcon css={svgClassFn} />
    </button>
  );
};

export default FilterPillRemove;
